const sv = {
  questionPaperLibrary: "Fragebanksbibliotek",
  questionPaperLibraryDescription:
    "Din dynamiska arbetsyta for att skapa enskilda fragor och utforma omfattande fraguppsattningar.",
  assessmentLibrary: "Bedomningsbibliotek",
  assessmentLibraryDescription:
    "Hantera scheman, bjud in deltagare och folj upp resultatrapporter i en centraliserad hubb.",
  myAssessmentWidgetTitle: "Min bedomning",
  myPreferences: "Mina preferenser",
  assessmentsForYou: "Bedomningar for dig",
  exploreAssessmentsAssignedToYou: "Utforska bedomningar som tilldelats dig",
  hitachiAcademy: "Hitachi Academy",
  essentialBusinessKnowledgeTestForYou:
    "Grundlaggande test i affarskunskap for dig",
  continuousLearningJourneyDescription:
    "Utformat for att hjalpa dig att forsta och starka dina affarsfardigheter under din kontinuerliga laranderesa",
  noActiveAssessmentsScheduledForYou:
    "Inga aktiva bedomningar ar schemalagda for dig",
  upcoming: "Kommande",
  notAttempted: "Ej forsokt",
  myAssessmentCardDescription:
    "Denna bedomning utvarderar dina tekniska, analytiska och problemlosningsfardigheter som en del av GlobalLogics campusrekryteringsprocess.",
  totalDuration: "Total varaktighet",
  startTime: "Starttid",
  questionAuthoring: "Fragforfattande",
  reviewQuestions: "Granska fragor",
  bulkUploadHistory: "Historik for massuppladdning",
  bulkActionHistory: "Historik for massatgarder",
  editQuestion: "Redigera fraga",
  inviteParticipants: "Bjud in deltagare",
  externalUserBulkUploadHistory:
    "Historik for massuppladdning av externa anvandare",
  assessmentSchedule: "Bedomningsschema",
  assessmentReport: "Bedomningsrapport",
  bulkHistory: "Masshistorik",
  myUpload: "Min uppladdning",
  bulkUpload: "Massuppladdning",
  createQuestion: "Skapa fraga",
  bulkUploadQuestions: "Massuppladdning av fragor",
  filters: "Filter",
  clear: "Rensa",
  searchByTitle: "Sok efter titel",
  refresh: "Uppdatera",
  refreshing: "Uppdaterar",
  reviewQuestionPapers: "Granska fraguppsattningar",
  myQuestionPapers: "Mina fraguppsattningar",
  viewQuestionBank: "Visa fragbank",
  createNew: "Skapa ny",
  sortBy: "Sortera efter",
  state: "Status",
  reviewed: "Granskad",
  reviewedTooltip:
    "Visa fraguppsattningar som har granskats och sedan publicerats.",
  all: "Alla",
  draft: "Utkast",
  published: "Publicerad",
  inReview: "Under granskning",
  sentBack: "Tillbakaskickad",
  readyToPublish: "Redo att publicera",
  draftDescription:
    "Skapandet av fraguppsattningen pagar fortfarande och ar annu inte tillgangligt for deltagare",
  publishedDescription:
    "Fraguppsattningen ar live och tillganglig for deltagare",
  inReviewDescription: "Fraguppsattningen granskas och ar annu inte godkand",
  sentBackDescription: "Fraguppsattningen har skickats tillbaka for revidering",
  readyToPublishDescription: "Fraguppsattningen ar redo att publiceras",
  createdAt: "Skapad",
  updatedAt: "Uppdaterad",
  publishedAt: "Publicerad",
  descending: "Fallande",
  ascending: "Stigande",
  success: "Framgång",
  error: "Fel",
  warning: "Varning",
  info: "Information",
  yes: "Ja",
  no: "Nej",
  noMatchingContentFound: "Inget matchande innehall hittades",
  noQuestionPapersAvailableForReview:
    "Inga fraguppsattningar tillgangliga for granskning",
  questionPaperNotYetCreated: "Fraguppsattning har inte skapats an",
  createQuestionPaperDescription:
    "Skapa en fraguppsattning for att utvardera deltagarnas fardigheter och kunskaper",
  createYourFirstQuestionPaper: "Skapa din forsta fraguppsattning",
  createQuestionPaperModalTitle: "Skapa fraguppsattning",
  questionsTab: "Frågor",
  questionPaperSettingsTab: "Frågepappersinställningar",
  editQuestionPaper: "Redigera frågepapper",
  save: "Spara",
  publish: "Publicera",
  sendForReview: "Skicka för granskning",
  sendingForReview: "Skickar för granskning",
  publishing: "Publicering",
  clone: "Klona",
  delete: "Radera",
  view: "Se",
  edit: "Redigera",
  close: "Nära",
  create: "Skapa",
  creating: "Skapande",
  confirm: "Bekräfta",
  cancel: "Avbryt",
  version: "Version",
  untitled: "Utan titel",
  noVersion: "Ingen version",
  title: "Titel",
  status: "Status",
  action: "Handling",
  createdBy: "Skapad av",
  createNewVersion: "+ Ny version",
  createNewVersionTitle: "Skapa ny version",
  deleteQuestionPaperPrompt:
    "Är du säker på att du vill ta bort det här frågeformuläret?",
  deleteQuestionPaperWithTitlePrompt:
    'Vill du ta bort det här frågeformuläret med titeln "{{title}}"?',
  cloneQuestionPaperPrompt: "Vill du klona detta frågepapper?",
  publishQuestionPaperPrompt:
    "Är du säker på att du vill publicera det här frågeformuläret?",
  sendForReviewQuestionPaperPrompt:
    "Är du säker på att du vill skicka det här frågeformuläret för granskning?",
  successfullyDeletedQuestionPaper: "Frågepappret har raderats",
  successfullyMovedQuestionPaperToDraft: "Frågepappret flyttades till utkast",
  successfullySavedQuestionPaperData: "Frågepappersdata har sparats",
  successfullyClonedQuestionPaper: "Klonade frågepappret framgångsrikt",
  successfullyCreatedQuestionPaper: "Frågepappret har skapats framgångsrikt",
  validationFailedWithFollowingErrors:
    "Validering misslyckades med följande fel:",
  failedStatusUpdateOf: "Misslyckad statusuppdatering av:",
  savedWithFollowingWarnings: "Sparad med följande varningar:",
  reviewedAndPublished: "Recenserad och publicerad",
  deleting: "Tar bort...",
  cloning: "Kloning...",
  assessment: "Värdering",
  public: "Offentlig",
  private: "Privat",
  visibility: "Synlighet",
  questionType: "Frågetyp",
  selectQuestionTypeAndVisibility: "Välj frågetyp och synlighet",
  singleChoice: "Enkelt val",
  multipleChoice: "Flerval",
  trueOrFalse: "Sant eller falskt",
  fillInTheBlanks: "Fyll i de tomma fälten",
  codingQuestion: "Kodningsfråga",
  subjectiveQuestion: "Subjektiv fråga",
  speakingQuestion: "Talande fråga",
  downloadTemplateEditAndReuploadQuestions:
    "Ladda ner mall, redigera och ladda upp listan med frågor igen",
  downloadExcelTemplateInstruction: "Ladda ner Excel-mallen med knappen nedan.",
  addQuestionsToSheetInstruction:
    "Lägg till dina frågor på bladet (instruktioner ingår).",
  uploadCompletedExcelInstruction:
    "Ladda upp den färdiga Excel-filen för att massimportera frågor.",
  uploading: "Laddar upp...",
  uploadQuestions: "Ladda upp frågor",
  completed: "Avslutad",
  invalid: "Ogiltig",
  initiated: "Initierad",
  failed: "Misslyckades",
  fileName: "Filnamn",
  templateType: "Malltyp",
  uploadedAt: "Uppladdad kl",
  actions: "Åtgärder",
  mcqTemplate: "MCQ mall",
  fibTemplate: "FIB-mall",
  monitorUploadExcelDescription:
    "Övervaka varje uppladdning av Excel-fil, kontrollera hur många frågor som lades till eller misslyckades och visa felinformation om det behövs.",
  reset: "Återställa",
  showing: "Visande",
  to: "till",
  of: "av",
  results: "resultat",
  noExcelFound: "Inget Excel hittades",
  cloneAssessmentConfirmation: "Bekräftelse av klonbedömning",
  cloneAssessmentWithTitlePrompt:
    'Är du säker på att du vill klona den här bedömningen med titeln "{{title}}"?',
  successfullyClonedAssessment: "Bedömningen klonades framgångsrikt",
  newVersionContentPrompt:
    "Du håller på att skapa en ny version av detta innehåll. Alla ytterligare ändringar kommer att sparas i denna version. Vill du fortsätta?",
  createVersionWithNumber: "Skapa (V{{version}})",
  addYourComment: "Lägg till din kommentar",
  maxLimitReached: "maxgräns nådd",
  deleteContentPrompt:
    "Är du säker på att du vill ta bort denna {{contentType}}?",
  deleteContentWithTitlePrompt:
    'Är du säker på att du vill ta bort denna {{contentType}} med titeln "{{title}}"?',
  schedulePreview: "Schemalägg förhandsgranskning",
  reschedule: "Boka om",
  cancelled: "Avbruten",
  copyLink: "Kopiera länk",
  assessmentIsCancelled: "Bedömningen är inställd",
  deleteConfirmation: "Ta bort bekräftelse",
  cancelConfirmation: "Avbryt bekräftelse",
  deleteAssessmentPrompt: "Är du säker på att du vill ta bort denna bedömning?",
  cancelAssessmentPrompt: "Är du säker på att du vill avbryta denna bedömning?",
  rescheduleAssessment: "Boka om bedömning",
  customTermsAndConditions: "Anpassade villkor",
  viewTermsAndConditions: "Se T&C",
  scheduleNewAssessment: "Schemalägg ny bedömning",
  selectQuestionPaper: "Välj Frågepapper",
  createAssessment: "Skapa bedömning",
  failedToLoadData: "Det gick inte att ladda data!",
  assessmentNotYetCreated: "Bedömningen har inte skapats ännu",
  createAssessmentDescription:
    "Skapa en bedömning för att utvärdera elevernas färdigheter och kunskaper",
  createYourFirstAssessment: "Skapa din första bedömning",
  failedToLoadSchedules: "Det gick inte att ladda scheman",
  errors: "Fel:",
  basicInformation: "Grundläggande information",
  assessmentName: "Bedömningsnamn",
  na: "NA",
  scheduleInstructions: "Schema Instruktioner",
  noInstructionsProvided: "Inga instruktioner tillhandahålls",
  accessCriteria: "Åtkomstkriterier",
  searchTags: "Sök taggar",
  viewAttributes: "Visa attribut",
  termsAndConditions: "Allmänna villkor",
  enabled: "Aktiverad",
  disabled: "Inaktiverad",
  requireCandidatesToAcceptTerms:
    "Kräv att kandidater accepterar T&C innan bedömningen påbörjas",
  proctoringSettings: "Proctoring-inställningar",
  enableVideoProctoring: "Aktivera Video Proctoring",
  maximumVideoViolationsAllowed: "Maximalt tillåtna videoöverträdelser",
  enableBrowserProctoring: "Aktivera webbläsarkontroll",
  maximumBrowserViolationsAllowed: "Maximalt tillåtna webbläsaröverträdelser",
  displayViolationsToCandidates: "Visa överträdelser för kandidater",
  actionWhenViolationLimitReached: "Åtgärd när överträdelsegränsen har nåtts",
  flagged: "Flaggad",
  terminate: "Avsluta",
  stakeholdersAndFeedback: "Intressenter och feedback",
  owner: "Ägare",
  recruiter: "Rekryterare",
  allowCandidateFeedback: "Tillåt kandidatfeedback",
  enableCandidateFeedbackDescription:
    "Gör det möjligt för kandidater att skicka feedback efter att ha slutfört bedömningen",
  schedulingAndTimerSettings: "Schemaläggning och timerinställningar",
  scheduleType: "Schematyp",
  loginWindow: "Inloggningsfönster",
  durationBased: "Varaktighetsbaserad",
  deadline: "Tidsfrist",
  autoCompleteMode: "Automatiskt kompletteringsläge",
  startDateAndTime: "Startdatum och tid",
  loginWindowInMinutes: "Inloggningsfönster (i minuter)",
  endDateAndTime: "Slutdatum och tid",
  timerEnabled: "Timer aktiverad",
  assessmentRules: "Bedömningsregler",
  assessmentPattern: "Bedömningsmönster",
  resultVisibility: "Resultat Synlighet",
  passPercentage: "Godkänd procent",
  maximumAttemptsAllowed: "Maximalt tillåtna försök",
  unlimitedAttempts: "Obegränsade försök",
  attempt: "försök",
  attempts: "försök",
  coolOffPeriodBetweenAttempts: "Avkylningsperiod mellan försök",
  questionDisplaySettings: "Frågevisningsinställningar",
  showQuestionTitle: "Visa frågans titel",
  showQuestionTitleDescription: "Visa frågans rubrik ovanför varje fråga",
  showHint: "Visa tips",
  hintLoading: "Du måste vänta innan du ser en annan ledtråd",
  allHintsShown: "Inga ledtrådar väntar",
  showHintDescription:
    "Aktivera tips för att hjälpa kandidaten under bedömningen",
  showExplanation: "Visa förklaring",
  hideExplanation: "Dölj förklaring",
  showExplanationDescription: "Visa förklaringar efter varje frågeinlämning",
  showQuestionMarks: "Visa frågetecken",
  showQuestionMarksDescription: "Visa poäng/poängvärdet för varje fråga",
  showWatermark: "Visa vattenstämpel",
  showWatermarkDescription:
    "Visa kandidatens e-postadress för varje fråga som en vattenstämpel",
  questionPaperPreview: "Förhandsvisning av frågepapper",
  questionPaperReview: "Frågepappersgranskning",
  createSchedule: "Skapa schema",
  reviewerComments: "Granskares kommentarer",
  reviewComments: "Granska kommentarer",
  sendBackQuestionPaperPrompt:
    "Är du säker på att du vill skicka tillbaka det här frågeformuläret?",
  moveQuestionPaperToDraftPrompt:
    "Är du säker på att du vill flytta detta frågepapper till utkast?",
  markQuestionPaperReadyToPublishPrompt:
    "Är du säker på att du vill markera detta frågeformulär som redo att publiceras?",
  questionPaperStatusUpdatedSuccessfully:
    "Frågepappersstatus har uppdaterats framgångsrikt!",
  newVersionQuestionPaperCreatedSuccessfully:
    "Ny version för frågepapper skapad framgångsrikt!",
  questionPaperClonedSuccessfully: "Frågepapper klonades framgångsrikt!",
  startAddingQuestionsPreview:
    "Börja lägga till frågor för att förhandsgranska det här",
  bulkInviteParticipants: "Bulk Bjud in deltagare",
  bulkInviteParticipantsDescription:
    "Bjud in flera deltagare samtidigt genom att ladda upp en förifylld Excel-fil. Använd mallen som tillhandahålls för att säkerställa rätt format.",
  maxParticipantsPerFileNote:
    "Max 200 deltagare per fil. Dubbletter eller ogiltiga poster kommer att hoppas över med ett fel.",
  downloadTemplate: "Ladda ner mall",
  creatingUser: "Skapar användare...",
  bulkInviteLabel: "Massinbjudan",
  createAndInvite: "Skapa & bjud in",
  myUploads: "Mina uppladdningar",
  enterIndividualsForInvite:
    "Ange namnen på en eller flera personer som du vill bjuda in till bedömningen",
  searchPeopleByEmailOrName: "Sök personer efter e-postadress eller namn",
  noResultsFound: "Inga resultat hittades",
  loading: "Laddar..",
  or: "Eller",
  multipleEmailsInviteDescription:
    "Lägg till flera användares e-postmeddelanden, separerade med kommatecken, för att bjuda in flera användare till bedömningen",
  addCandidates: "Lägg till kandidater",
  pleaseEnterValidNameOrEmail: "Ange ett giltigt namn eller e-postadress",
  pleaseEnterValidEmailAddress: "Ange en giltig e-postadress",
  someEmailsCouldNotBeAdded: "Vissa e-postadresser kunde inte läggas till",
  checkInvalidEmailIds:
    "Kontrollera följande e-post-ID - de verkar vara ogiltiga:",
  failedToSendInvitesFollowingEmails:
    "Det gick inte att skicka inbjudningar till följande e-postmeddelanden:",
  successfullyInvitedMembers: "{{count}} medlem har bjudits in",
  validationFailed: "Validering misslyckades",
  excelUploadedSuccessfully: "Excel har laddats upp",
  invalidBulkNominationTemplate: "Ogiltig mall för massnominering",
  actionCompletedWithWarnings: "Åtgärden slutförd med följande varningar:",
  actionFailedWithErrors:
    "Åtgärden kunde inte slutföras och avslutades med följande fel:",
  trackBulkOperationsAndResults:
    "Spåra alla dina bulkoperationer och deras resultat",
  partiallySaved: "Delvis sparad",
  statusInitiatedDescription:
    "Begäran om uppdatering av frågan har skickats och håller på att behandlas.",
  statusCompletedDescription: "Alla valda frågor uppdaterades framgångsrikt.",
  statusFailedDescription:
    "Ingen av de valda frågorna kunde bearbetas framgångsrikt.",
  statusPartiallySavedDescription:
    "Vissa frågor sparades framgångsrikt, medan andra stötte på problem.",
  draftReadyToPublishToPublish: "Utkast/Redo att publicera -> Publicera",
  actionType: "Åtgärdstyp",
  uploadedOn: "Uppladdad på",
  viewDetails: "Visa detaljer",
  loadingRecords: "Laddar poster...",
  noRecordsFound: "Inga poster hittades",
  recordsPerPage: "Rekord per sida:",
  page: "Sida",
  untitledQuestion: "Namnlös fråga",
  globalLogic: "GlobalLogic",
  aiGenerated: "AI genererad",
  fullScreen: "Helskärm",
  exitFullScreen: "Avsluta helskärm",
  skills: "Färdigheter",
  tags: "Taggar",
  allowedCodingLanguages: "Tillåtna kodningsspråk",
  marks: "Märken",
  lastUpdatedAt: "Senast uppdaterad kl",
  solutionCode: "Lösningskod",
  solution: "Lösning",
  starterCode: "Startkod",
  options: "Alternativ",
  explanation: "Förklaring",
  hint: "Antydan",
  deleteQuestion: "Ta bort fråga",
  noSections: "Inga avsnitt tillagda",
  editAndPublish: "Redigera & publicera",
  sendBackToDraftInstruction:
    "Klicka på knappen Skicka tillbaka för att skicka tillbaka frågan till utkastet.",
  updateStatusReadyToPublishInstruction:
    "Klicka på knappen Redo att publicera för att uppdatera statusen.",
  successfullyUpdatedStatus: "Statusen har uppdaterats",
  dismiss: "Avfärda",
  ongoing: "Pågående",
  toBeLaunched: "Kommer att lanseras",
  contentExpired: "Innehållet har gått ut",
  notApplicable: "Ej tillämpligt",
  expiresSoon: "Löper ut snart",
  contentCreationInProgressTooltip:
    "Innehållsskapandet pågår fortfarande och är ännu inte tillgängligt för elever",
  contentLiveAccessibleTooltip:
    "Innehållet är live och tillgängligt för elever",
  contentAvailableWithinDatesTooltip:
    "Innehållet är för närvarande tillgängligt eftersom det ligger inom start- och utgångsdatum",
  contentNotLaunchedAvailableOnTooltip:
    "Innehållet har ännu inte lanserats och blir tillgängligt den",
  contentExpiredOnTooltip: "Det här innehållet gick ut den",
  statusAvailableAfterPublishTooltip:
    "Status blir tillgänglig när innehållet har publicerats",
  contentExpiresWithin48HoursTooltip:
    "Innehållet kommer att löpa ut inom 48 timmar.",
  moveToDraftOrCloneToEdit:
    "Flytta det till utkast eller klona det för att göra ändringar",
  webContent: "Webbinnehåll",
  eLearning: "E-lärande",
  untitledContent: "Namnlöst innehåll",
  sendToDraft: "Skicka till utkast",
  sendToDraftPublishedInstruction:
    "Det här innehållet är redan publicerat. Om du vill göra ändringar klickar du på knappen Skicka till utkast.",
  copyLinkForLearner: "Kopiera länk för elev",
  questionPaperName: "Namn på frågeformulär",
  type: "Typ",
  duration: "Varaktighet",
  minutes: "Minuter",
  difficultyLevel: "Svårighetsgrad",
  language: "Språk",
  timezone: "Tidszon",
  preferredLocation: "Föredragen plats",
  notSelected: "Inte vald",
  selectedPreferencesHeading: "Valda inställningar",
  selectedPreferencesInfo: "Valda inställningar för en smidig upplevelse",
  shortDescription: "Kort beskrivning",
  totalMarks: "Totalpoäng",
  questionPaperInstructions: "Instruktioner för frågeformulär",
  expiryDate: "Utgångsdatum",
  knowledgeCategory: "Kunskapskategori",
  category: "Kategori",
  subCategory: "Underkategori",
  region: "Område",
  usage: "Användning",
  internalUseOnly: "Endast for intern anvandning",
  externalUseOnly: "Endast for extern anvandning",
  availableForAll: "Tillgangligt for alla",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Latinamerika",
  northAmerica: "Nordamerika",
  globalRegion: "Global",
  automotive: "Fordonsindustri",
  bankingFinancialServicesInsurance: "Bank, finans och försäkring",
  connectivitySolutionsCommunication: "Anslutningslösningar/kommunikation",
  consumerRetail: "Konsument och detaljhandel",
  healthcareLifeSciences: "Hälso- och life science",
  manufacturingAndIndustrial: "Tillverkning och industri",
  mediaEntertainment: "Media och underhållning",
  technology: "Teknologi",
  other: "Annat",
  behavioralInterpersonal: "Beteende/interpersonell",
  technical: "Teknisk",
  processAndTools: "Processer och verktyg",
  polishLanguage: "Polska",
  spanishLanguage: "Spanska",
  japaneseLanguage: "Japanska",
  germanLanguage: "Tyska",
  ukrainianLanguage: "Ukrainska",
  swedishLanguage: "Svenska",
  romanianLanguage: "Rumänska",
  slovakLanguage: "Slovakiska",
  croatianLanguage: "Kroatiska",
  englishUsLanguage: "Engelska (US)",
  englishUkLanguage: "Engelska (UK)",
  englishInLanguage: "Engelska (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Fordonsstandarder och protokoll",
  businessAnalysis: "Affärsanalys",
  cCpp: "C/C++",
  cloudDataScience: "Molnbaserad data science",
  bigData: "Big Data",
  dataAnalytics: "Dataanalys",
  databaseTech: "Databas",
  developmentTools: "Utvecklingsverktyg",
  devops: "DevOps",
  embedded: "Inbyggda system",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linux-kärna",
  mobileDev: "Mobil utveckling",
  networking: "Nätverk",
  operatingSystemsServers: "Operativsystem och servrar",
  otherTech: "Annat - Tech",
  productivityTools: "Produktivitetsverktyg",
  programmingLangOther: "Programmeringsspråk - Övrigt",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Programvaruteknik",
  uxUi: "UX/UI",
  architectureTech: "Arkitektur",
  golang: "Golang",
  requirementEngineeringTechnicalWriting: "Kravhantering/Tekniskt skrivande",
  onboarding: "Onboarding",
  glTools: "GL-verktyg",
  processAndPolicies: "Processer och policyer",
  communicationSubCategory: "Kommunikation",
  personalEffectiveness: "Personlig effektivitet",
  methodologies: "Metodiker",
  projectManagement: "Projektledning",
  peopleManagement: "Personalledning",
  leadershipPrograms: "Ledarskapsprogram",
  domain: "Domän",
  reviewer: "Granskare",
  none: "Ingen",
  questionPaperPreviewBreadcrumb:
    "Förhandsgranskning av frågeformulär: {{title}}",
  questionPaperInReviewContactReviewer:
    "Det här frågeformuläret granskas just nu. Kontakta granskaren.",
  randomization: "Randomisering",
  randomizationInSectionDescription:
    "Fragor i den har sektionen visas for kandidater i slumpmassig ordning",
  questionPreviewPlaceholderImage: "Platshållare för frågeförhandsgranskning",
  createNewVersionPromptWithNumber: "Skapa ny version (V{{version}})?",
  questionPreviewBreadcrumb: "Fragaforhandsvisning: {{title}}",
  questionPreviewTitle: "Fragaforhandsvisning",
  adminView: "Administratorsvy",
  candidateView: "Kandidatvy",
  viewAsCandidate: "Visa som kandidat",
  closePanel: "Stang panel",
  internalQuestion: "Intern fraga",
  expiresOn: "Galler till",
  expiredLabel: "Utgangen",
  solutionNotAdded: "Losning har inte lagts till",
  testCases: "Testfall",
  testCasesNotAdded: "Testfall har inte lagts till",
  starterCodeNotAdded: "Startkod har inte lagts till",
  groupTitleLengthValidation:
    "Grupptiteln maste vara mer an 5 och mindre an 120 tecken",
  addTitleHere: "Lagg till titel har...",
  groupUpdatedSuccessfully: "Gruppen har uppdaterats",
  groupDeletedSuccessfully: "Gruppen har raderats",
  group: "Grupp",
  numberOfQuestionsToBeShown: "Antal fragor som ska visas",
  questionLimitPerSectionDescription:
    "Visa endast ett visst antal fragor for kandidater i sektionerna",
  numberOfQuestionsToShow: "Antal fragor att visa {{picked}}/{{total}}",
  collapseGroup: "Falla ihop grupp",
  expandGroup: "Expandera grupp",
  groupSetupStartAddingQuestions:
    "En grupp ar konfigurerad for det har avsnittet. Borja lagga till fragor i den.",
  addMoreQuestions: "Lagg till fler fragor",
  addQuestionFromLibrary: "Lagg till fraga fran biblioteket",
  questionDeletedSuccessfully: "Fragan raderades",
  questionsShownCountUpdated: "Antalet visade fragor har uppdaterats",
  failedToDeleteQuestion: "Det gick inte att radera fragan",
  caseSensitive: "Skiftlageskanslig",
  caseSensitiveDescription:
    "Om aktiverat maste elever ange svaret med exakt samma stora och sma bokstaver.",
  enterYourAnswerBelow: "Ange ditt svar nedan",
  caseSensitiveAnswerInfo:
    "Den har fragan ar skiftlageskanslig, sa ange dina svar med exakta stora och sma bokstaver.",
  answerWithNumber: "Svar {{number}}",
  inviteEmailsPlaceholder:
    "användare1@globallogic.com, användare2@globallogic.com",
  visibleTestCases: "Synliga testfall",
  hiddenTestCases: "Dolda testfall",
  visibleLabel: "Synlig",
  hiddenLabel: "Dold",
  responseSetting: "Svarsinstallningar",
  recordingLimit: "Inspelningsgrans",
  minimumResponseDuration: "Minsta svarstid",
  uploadLimit: "Uppladdningsgrans",
  practiceAllowed: "Ovning tillaten",
  standardEvaluationRubricInfo:
    "Detta ar standardbedomningsrubriken som kommer att anvandas for att bedoma kandidatens svar pa denna fraga.",
  criteria: "Kriterier",
  weightPercentage: "Vikt(%)",
  viewRemarks: "Visa anmärkningar",
  input: "Inmatning",
  expectedOutput: "Förväntad utmatning",
  actualOutput: "Faktisk utmatning",
  untitledSection: "Namnlös avsnitt",
  testSectionDescription: "Testsektion beskrivning",
  groupAddedSuccessfully: "Grupp tillagd framgångsrikt",
  addGroupToSection: "Lägg till grupp i avsnitt",
  deleteSection: "Ta bort avsnitt",
  questionPaperDetails: "Detaljer för frågedokument",
  skillsInfoMessage:
    "Lista de nyckelkompetenser som detta frågedokument är avsett att bedöma.",
  contentSettings: "Innehållsinställningar",
  stakeholderAndReview: "Intressenter och granskning",
  statusType: "Statustyp",
  notReviewed: "Ej granskad",
  sourceType: "Källtyp",
  proficiency: "Skicklighet",
  beginner: "Nybörjare",
  intermediate: "Mellanliggande",
  advanced: "Avancerad",
  wecp: "WECP",
  enterMarks: "Ange märken",
  removeSkill: "Ta bort skicklighet",
  searchSkills: "Sökkunskaper",
  noSkillsFound: "Inga färdigheter hittades.",
  enterTag: "Ange en tagg",
  enterOwner: "Ange ägare",
  enterReviewer: "Ange granskare",
  noUserWithRole: "Ingen användare med denna roll hittades",
  createSection: "Skapa avsnitt",
  untitledGroup: "Grupp utan titel",
  createGroup: "Skapa grupp",
  collapseSections: "Dölj avsnitt",
  expandSections: "Visa avsnitt",
  assessmentNamePlaceholder: "Ange bedömningens namn",
  questionPaperTitleInfo: "Ange en tydlig, beskrivande titel för frågepappret.",
  shortDescriptionPlaceholder: "Ge en kort beskrivning",
  shortDescriptionInfo:
    "En kort sammanfattning som förklarar vad frågeformuläret omfattar.",
  questionPaperInstructionsInfo:
    "Skriv instruktionerna som kandidaterna kommer att se innan du startar frågepappret. Inkludera viktig information som avsnittsregler, frågeformat, navigeringstips och inlämningsriktlinjer.",
  questionPaperInstructionsPlaceholder:
    "Lägg till alla viktiga instruktioner för eleverna innan de påbörjar bedömningen - varaktighet, godkända kriterier, tillåtna verktyg eller riktlinjer.",
  totalMarksAutoCalculatedInfo:
    "Totalt antal poäng kommer automatiskt att beräknas baserat på antalet frågor som valts för varje grupp. Om antalet frågor som ska visas är satt till 0, kommer den gruppen att exkluderas från det totala betyget.",
  questionPaperType: "Typ av frågepapper",
  questionPaperTypeInfo: "Välj formatet på frågepappret.",
  durationInfo:
    "Ställ in den totala tidsgränsen för att fylla i frågepappret (i minuter).",
  difficultyLevelInfo:
    "Välj den förväntade svårighetsgraden baserat på kandidatens erfarenhet.",
  languageInfo: "Välj det språk som frågeformuläret ska presenteras på.",
  tagsInfo:
    "Lägg till nyckelord för att hjälpa andra att hitta det här frågeformuläret genom en sökning.",
  selectCategory: "Välj Kategori",
  createLevel: "Skapa",
  evaluate: "Utvärdera",
  analyze: "Analysera",
  apply: "Tillämpas",
  understand: "Förstå",
  remember: "Komma ihåg",
  allowedCodingLanguagesRequiredInfo:
    "fältet krävs endast när du lägger till kodningsfrågor i frågepappret.",
  knowledgeCategoryInfo:
    "Välj den kognitiva färdighetsnivån som detta frågepapper är inriktat på, t.ex. Kom ihåg, förstå, tillämpa.",
  allowedCodingLanguagesInfo:
    "Välj de programmeringsspråk som är tillåtna för kodningsfrågor i detta frågepapper.",
  expiryDateInfo:
    "Ställ in ett valfritt datum efter vilket detta frågepapper inte längre ska användas.",
  visibilityInfo: "Välj frågepapprets synlighet",
  visibilityLockedInfo:
    "När ett frågeformulär har publicerats med offentlig synlighet kommer alla dess andra versioner också att ha offentlig synlighet. På samma sätt, om den publiceras som privat, kommer alla versioner att förbli privata.",
  reviewRequired: "Granskning krävs",
  reviewRequiredLockedInfo:
    'Inställningen "Review Required" synkroniseras med alla versioner av ett frågeformulär. Om någon version publiceras med granskning aktiverad eller inaktiverad kommer samma inställning att gälla för alla versioner och kan inte redigeras individuellt.',
  reviewRequiredInfo:
    "Aktivera om detta frågeformulär måste genomgå en formell granskningsprocess innan det publiceras.",
  savingData: "Sparar data...",
  questionDataSavedSuccessfully: "Frågedata har sparats",
  sendQuestionForReviewInstruction:
    "Klicka på knappen Skicka för granskning för att skicka den till granskaren för att få den granskad!",
  publishQuestionInstruction:
    "Klicka på publicera-knappen för att publicera frågan.",
  noLearningContentAddedAfterSelectingYes:
    "Inget lärandeinnehåll har lagts till efter att ha valt Ja",
  expectedTimeInMinutes: "Förväntad tid (i min)",
  codingMarksAutoCalculatedInfo:
    "Dessa poäng beräknas automatiskt baserat på de dolda testfallen som lagts till i denna fråga",
  skillsInfoMessageQuestion:
    "Tillhandahåll specifika färdigheter som deltagarna kommer att förvärva från frågan",
  skillsSubtitleQuestion:
    "Ställ in de färdigheter som är förknippade med denna fråga",
  allowedCodingLanguagesInfoQuestion:
    "Välj tillgängliga språk för att lösa denna fråga",
  selectCodingLanguages: "Välj kodningsspråk",
  allLanguages: "Alla språk",
  tagsInfoQuestion:
    "Ange nyckelord för att kategorisera, beskriva och identifiera händelsen",
  tagsSubtitleQuestion: "Ställ in taggarna för snabbsökning",
  knowledgeCategorySubtitleQuestion:
    "Hjälper till att kategorisera frågor efter kognitiva färdighetsnivåer.",
  explanationNotAvailableForSpeakingQuestion:
    "Förklaring inte tillgänglig för talfråga",
  ownerVersionSyncInfo:
    "Om vi ​​byter ägare till denna version kommer den också att uppdateras i alla skapade versioner.",
  ownerInfoMessage: "Välj primära ägare till frågan",
  ownerReviewerCannotBeSame: "ägare och granskare kan inte vara samma",
  reviewerInfoMessage: "Välj en individ eller grupp av individer som granskare",
  stakeholdersUpdatedSuccessfully: "Intressenter uppdaterade framgångsrikt!",
  unexpectedErrorCreatingNewVersion:
    "Ett oväntat fel inträffade när en ny version skapades.",
  previewAndPublish: "Förhandsgranska och publicera",
  viewAnalytics: "Visa Analytics",
  cloneQuestionPrompt: "Vill du klona den här frågan?",
  evaluationRubric: "Utvärderingsrubriken",
  problemStatement: "Problembeskrivning",
  problemStatementPlaceholder:
    "Ange problembeskrivningen eller uttalandet för frågesport",
  addOptionsAndMarkCorrectAnswer: "Lägg till alternativ och markera rätt svar",
  markCorrectAnswer: "Markera rätt svar",
  addCorrectAnswer: "Lägg till rätt svar",
  enterCorrectAnswerForBlank: "Ange rätt svar för tomma {{nummer}}",
  blankWithNumber: "Tomt {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    'Lägg till en korrekt problemformulering med ett "&blank" för att aktivera svaret.',
  enterSolution: "Ange lösningen",
  enterExplanation: "Skriv in förklaringen",
  codingSolutionExplanationPlaceholder:
    "Förklara kort logik, tillvägagångssätt och kantfall som hanteras i den optimala lösningen",
  optionWithNumber: "Alternativ {{number}}",
  enterExplanationForAnswer: "Ange förklaringen till svar {{nummer}}",
  addOptionToEnableExplanation:
    "Lägg till alternativ {{nummer}} för att aktivera förklaringen.",
  enterExplanationForBlank: "Ange förklaringen för tomt {{nummer}}",
  addProblemStatementWithBlankToEnableExplanation:
    'Lägg till en korrekt problemformulering med ett "&blank" för att aktivera förklaringen.',
  enterHint: "Ange tipset",
  addUpTo3Hints: "Lägg till upp till 3 tips",
  addMoreOptions: "Lägg till fler alternativ",
  answer: "Svar",
  exitCodeBlockInfo:
    'För att lämna kodblocket, gå till slutet av raden och tryck "Enter" tre gånger',
  fibBlankInsertionInfo:
    'För att lägga till en blank, markera text och klicka på knappen "Infoga blank", eller lägg till &blankN manuellt, där N kan vara vilket heltal som helst, t.ex.: &blank1;',
  htmlEditorAccessInfo:
    "För att lägga till kod eller ha kontroll över formatet kan du komma åt HTML-redigeraren genom att klicka på redigeringsikonen",
  skillSelectionCannotBeEmpty: "Val av färdighet får inte vara tomt",
  maxDurationInfo:
    "Maximal tid för en användare att spela in sitt svar på denna fråga.",
  minDurationInfo:
    "Minsta nödvändiga inspelningstid som en användare måste fylla i innan de skickar sitt svar.",
  uploadLimitInfo:
    "Antalet gånger en användare kan spela in sitt svar på nytt innan den slutliga inlämningen.",
  textQuestionTitle: "Det här är en textfråga",
  audioRecordQuestionTitle: "Det här är en ljudinspelningsfråga",
  audioUploadQuestionTitle: "Detta är en fråga för uppladdning av ljud",
  videoRecordQuestionTitle: "Det här är en fråga om videoinspelning",
  videoUploadQuestionTitle: "Det här är en fråga för uppladdning av video",
  subjectiveQuestionUploadConfigTitle:
    "Subjektiv fråga Ladda upp konfigurationstitel",
  recordingLimitInMinutes: "Inspelningsgräns (i min)",
  minimumResponseDurationInMinutes: "Minsta svarstid (i min)",
  recordingLimitLessThanTwenty: "Inspelningsgränsen måste vara mindre än 20",
  recordingLimitGreaterThanOrEqualOne:
    "Inspelningsgränsen måste vara större än eller lika med 1",
  minimumDurationLessThanRecordingLimit:
    "Minsta svarstid måste vara mindre än inspelningsgränsen",
  durationGreaterThanPointFive: "Varaktigheten måste vara längre än 0,5",
  uploadLimitGreaterThanZero: "Uppladdningsgränsen måste vara större än 0",
  addFieldSelectCodingLanguagesInfo:
    "För att lägga till en {{fieldLabel}}, välj tillåtna kodningsspråk i avsnittet '{{basicDetails}}' först.",
  basicDetails: "Grundläggande detaljer",
  loadingEditor: "Laddar redigerare...",
  run: "Kör",
  writingSolutionInLanguage: "Du skriver just nu en lösning i",
  changingToLanguageWillClearInput: "Byter till",
  unsavedChangesWillBeLostInLanguage: "Dina osparade ändringar i",
  changeLanguage: "Byt språk",
  testCase: "Testfall",
  add: "Tillägga",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Lägg till minst 2 synliga testfall och 3 dolda testfall nedan",
  visibleToCandidatesForSelfEvaluation:
    "Synlig för kandidater för självutvärdering",
  noVisibleTestCasesAddedYet:
    "Inga synliga testfall har lagts till ännu. Klicka på knappen nedan för att lägga till en.",
  visibleTestCasesCannotExceedTwenty:
    "Synliga testfall får inte vara fler än 20",
  addMoreVisibleTestCases: "Lägg till fler synliga testfall",
  maximumTestCasesLimitReached: "Maximal gräns för testfall har uppnåtts",
  hiddenToCandidatesRunsAfterSubmit:
    "Gömd för kandidater, körs efter att kandidaten lämnat in",
  noHiddenTestCasesAddedYet:
    "Inga dolda testfall har lagts till ännu. Klicka på knappen nedan för att lägga till en.",
  hiddenTestCasesCannotExceedTen: "Dolda testfall får inte vara fler än 10",
  addMoreHiddenTestCases: "Lägg till fler dolda testfall",
  hiddenTestCase: "Dolt testfall",
  visibleTestCase: "Synligt testfall",
  someQuestionsCouldNotBeUpdated:
    "Vissa frågor kunde inte uppdateras. Granska frågorna och försök igen.",
  publishSummary: "Publicera sammanfattning",
  sendForReviewSummary: "Skicka för granskning Sammanfattning",
  moveToDraftSummary: "Flytta till Utkast Sammanfattning",
  actionSummary: "Åtgärdssammanfattning",
  publishSummarySubtitle:
    "Här är sammanfattningen av din publiceringsåtgärd. Granska detaljerna nedan.",
  sendForReviewSummarySubtitle:
    "Här är sammanfattningen av din begäran om granskning. Granska detaljerna nedan.",
  moveToDraftSummarySubtitle:
    "Här är sammanfattningen av din övergång till ett utkast till åtgärd. Granska detaljerna nedan.",
  actionSummarySubtitle:
    "Här är sammanfattningen av din åtgärd. Granska detaljerna nedan.",
  successfully: "Framgångsrikt",
  failedTo: "Misslyckades",
  moveToDraft: "Flytta till Utkast",
  details: "Detaljer",
  questionTitle: "Frågans titel",
  reason: "Resonera",
  showLess: "Visa mindre",
  showMoreCount: "Visa {{count}} till",
  uploadedAllCountItems: "Laddade upp alla {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Delvis uppladdad {{successCount}}/{{totalCount}} {{item}}",
  users: "användare",
  questions: "frågor",
  viewErrors: "Visa fel",
  errorsWithFileName: "Fel - {{filnamn}}",
  inputIsRequired: "Inmatning krävs",
  expectedOutputIsRequired: "Förväntad utgång krävs",
  expectedOutputCannotBeBlank:
    "Förväntad utdata får inte vara tom eller bara blanksteg",
  marksMustBeNumber: "Märken ska vara en siffra",
  marksAreRequired: "Betyg krävs",
  hiddenTestCaseMarksGreaterThanZero:
    "Poäng för dolda testfall bör vara större än 0 för att fortsätta.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Poäng för dolda testfall bör inte överstiga 30 000.",
  explanationMinFiveIfProvided:
    "Förklaringen måste vara minst 5 tecken om den tillhandahålls",
  explanationIsRequired: "Förklaring krävs",
  explanationMinFiveNotBlank:
    "Förklaringen måste vara minst 5 tecken och inte bara mellanslag",
  provideInput: "Ge input",
  provideExpectedOutput: "Ge förväntad produktion",
  enterScore: "Ange poäng",
  optional: "frivillig",
  explainTestCase: "Förklara testfallet",
  updateTestCase: "Uppdatera testfall",
  addTestCase: "Lägg till testfall",
  deleteQuestionWithTitlePrompt:
    "Är du säker på att du vill ta bort den här frågan med titeln '{{title}}'?",
  errorFetchingData: "Det gick inte att hämta data",
  rowNumber: "Radnummer",
  columnName: "Kolumnnamn",
  useCase: "Användningsfall",
  startsAt: "Börjar kl",
  endsAt: "Slutar kl",
  invite: "Bjud in",
  viewReport: "Visa rapport",
  successfullyDeletedAssessment: "Bedömningen har tagits bort",
  successfullyFreezeActionAssessment: "{{action}} bedömningen framgångsrikt",
  freezeOperationFailed: "Frysningsåtgärden misslyckades",
  deleteAssessmentWithTitlePrompt:
    "Är du säker på att du vill ta bort den här bedömningen med titeln '{{title}}'?",
  freeze: "Frysa",
  unfreeze: "Frigör upp",
  freezeAssessmentPrompt:
    "Är du säker på att du vill {{action}} denna bedömning?",
  expiresAt: "Går ut kl",
  seePreview: "Se Förhandsgranska",
  schedule: "Schema",
  skillBenchmarking: "Skicklighetsbenchmarking",
  skillBenchmarkingOverview:
    "En översikt över deltagarnas färdigheter i specifika färdigheter.",
  proctoringAnalysis: "Proctoring Analys",
  proctoringAnalysisOverview:
    "En snabb översikt över de proctoring-relaterade aspekterna av bedömningen.",
  proctoringStatus: "Övervakningsstatus",
  noIrregularitiesReported: "Inga oegentligheter rapporterade.",
  monitoringOverview: "Övervakningsöversikt",
  complianceNoIncidents:
    "Efterlevnad av bedömningsregler; inga incidenter eller flaggade beteenden.",
  viewEvidenceClicked: "Klickade bevis!",
  marksObtained: "Erhållna betyg",
  correctAnswer: "Rätt svar",
  wrongAnswer: "Fel svar",
  sectionWiseAnalysis: "Sektionsvis analys",
  sectionWiseAnalysisOverview:
    "En översikt över varje fråga och kandidatens svar.",
  openAllSections: "Öppna alla sektioner",
  closeAllSections: "Stäng alla avsnitt",
  sectionWithNumber: "Avsnitt {{number}}:",
  score: "Göra",
  questionAnalysis: "Frågeanalys",
  questionTitleFallback: "Frågans titel",
  candidateAnswer: "Kandidatens svar",
  loadAllQuestions: "Ladda alla {{count}} {{item}}",
  attemptWithNumber: "Försök #{{number}}",
  invalidReportUrl: "Ogiltig rapportadress",
  failedToDownloadReportTryAgainLater:
    "Det gick inte att ladda ned rapporten. Försök igen senare!",
  downloadReport: "Ladda ner rapport",
  participantName: "Deltagarens namn",
  dateOfAttempt: "Datum för försöket",
  fail: "Misslyckas",
  pass: "Passera",
  userScoredInAssessment: "{{name}} fick {{percentage}} i bedömningen.",
  overallSummary: "Övergripande sammanfattning",
  sectionAnalytics: "Sektionsanalys",
  allAttempts: "Alla försök",
  bestAttempt: "Bästa försöket",
  latestAttempt: "Senaste försöket",
  participantList: "Deltagarlista",
  totalParticipantsInvited: "Totalt antal deltagare inbjudna",
  notStarted: "Inte startat",
  inProgress: "Pågår",
  resultsInProgress: "Resultat pågår",
  searchByNameOrEmail: "Sök på namn eller e-post",
  noUsersAvailableReportCannotBeGenerated:
    "Inga användare tillgängliga - rapport kan inte genereras.",
  userName: "Användarnamn",
  totalAttempt: "Totalt försök",
  percentage: "Procentsats(%)",
  attemptTimeline: "Försök tidslinje",
  noDataFound: "Ingen data hittades",
  outOfMarks: "{{obtained}} av {{max}} markeringar",
  resultInProcess: "Resultat pågår",
  participantNotFound: "Deltagaren hittades inte!",
  searchedParticipantNotFound: "Sökt deltagare hittades inte!",
  noParticipantEnrolled: "Inga deltagare är anmälda!",
  noDataToDisplay: "Inga data att visa",
  participantsPerPage: "Deltagare per sida:",
  actionFailed: "Åtgärden misslyckades",
  failedToRemoveUser: "Det gick inte att ta bort användare",
  bestScoreAcrossAttemptsInfo:
    "Indikerar den bästa poängen som uppnåtts över flera försök.",
  successfullyRemovedUser: "Användaren har tagits bort",
  successfullyReinvitedUser: "Bjud in användaren på nytt",
  reinviteTooltip:
    "Bjud in på nytt deltagare som ännu inte påbörjat fortlöpande bedömningen",
  reInvite: "Bjud in igen",
  noParticipantsInvitedYet: "Inga deltagare har bjudits in ännu",
  scheduleExpired: "Schema har löpt ut",
  assessmentIsOngoing: "Utvärdering pågår",
  assessmentCompleted: "Bedömning avklarad",
  resultNotProcessed: "Resultatet har inte bearbetats",
  assessmentNotStarted: "Bedömningen har inte påbörjats",
  remove: "Ta bort",
  confirmReInvitation: "Bekräfta återinbjudan",
  confirmReinviteMessage:
    "Är du säker på att du vill bjuda in deltagare som ännu inte har påbörjat den pågående bedömningen igen?",
  removeUserWithNamePrompt: "Är du säker på att du vill ta bort '{{name}}'?",
  groupType: "Grupptyp",
  objectiveGroupType: "Mål",
  codingGroupType: "Kodning",
  subjectiveTextSpeakingGroupType: "Subjektiv (text/talande)",
  groupTypeImmutableInfo:
    "Grupptyp kan inte ändras senare. Endast frågor av den typen kan läggas till.",
  sameMarkGroupingTitle:
    "Frågor kan bara grupperas om de har samma märkesvärde",
  sameMarkGroupingDescription:
    "Att blanda poängvärden (t.ex. 2 poäng och 5 poäng) i en grupp kan leda till olika sektionspoäng när bara några frågor väljs. Gruppera liknande frågor för att hålla poängen konsekventa.",
  searchQuestion: "Sökfråga",
  addAllSelectedQuestions: "Lägg till alla {{count}} valda frågor",
  singleQuestionSelectedCount: "{{count}} fråga vald",
  allQuestionsSelectedCount: "Alla {{count}} frågor valda",
  selectedCountOfTotalQuestions: "Valda {{selected}} av {{total}} {{label}}",
  addSelectedQuestion: "Lägg till den valda frågan",
  validationErrors: "Valideringsfel",
  failedToAddToGroup: "Det gick inte att lägga till i gruppen",
  questionsAddedSuccessfullyWithCount: "{{count}} frågor har lagts till",
  successfullyUpdatedAssessment: "Bedömningen har uppdaterats",
  editCustomTnc: "Redigera anpassade villkor",
  addCustomTnc: "Lägg till anpassade villkor",
  attributes: "Attribut",
  added: "Tillagda",
  addAttributes: "Lägg till attribut",
  clickHereToAddEditAttributes:
    "Klicka här för att lägga till eller redigera attribut",
  clickHereToAddAttributes: "Klicka här för att lägga till attribut",
  addTncAndSave: "Lägg till villkor och spara",
  savedWithFollowingErrors: "Sparad med följande fel",
  selectDomain: "Välj domän",
  selectRegion: "Välj region",
  selectUsage: "Välj användning",
  selectCategoryFirst: "Välj kategori först",
  selectSubCategory: "Välj underkategori",
  addAttributesAndSave: "Lägg till attribut och spara",
  questionPaperTimer: "Timer för frågeformulär",
  sectionLevelTimer: "Timer på avsnittsnivå",
  questionLevelTimer: "Timer på frågenivå",
  loginWindowDescription:
    "Kandidater kan endast gå med inom ett begränsat tidsfönster efter starttiden.",
  durationBasedDescription:
    "Sluttiden beräknas automatiskt utifrån starttid + provtid.",
  deadlineDescription:
    "Fast start- och sluttid; kandidater måste vara klara före deadline.",
  loginWindowInfo:
    "Inloggningsfönstret är den tid (i minuter) under vilken kandidater kan starta bedömningen efter den schemalagda starttiden. När inloggningsfönstret stängs kan ingen ny kandidat ansluta. Inloggningsfönstret måste vara mindre än eller lika med provets totala tid.",
  assessmentDurationInfo:
    "Ställ endast in starttiden. Systemet beräknar automatiskt sluttiden genom att lägga till provtiden.",
  startTimeMinAheadInfo:
    "Starttiden måste vara minst 15 minuter efter den aktuella tiden.",
  loginWindowExample:
    "Exempel: Om starttiden är 09:00 och inloggningsfönstret är 30 minuter kan kandidater starta mellan 09:00 och 09:30 med 5 minuters extra buffert.",
  assessmentDurationExample:
    "Exempel: Om starttiden är 09:00 och provtiden är 60 minuter kommer bedömningen att sluta kl. 10:00 med 5 minuters extra buffert.",
  freeFlow: "Fritt flöde",
  oneByOne: "En i taget",
  subjectiveNoResultInfo: "Subjektiv information för 'Inget resultat'",
  candidateResultVisibility: "Synlighet av resultat för kandidat",
  noResult: "Inget resultat",
  passPercentageRangeError: "Fel i intervallet för godkand procentandel",
  attemptsAllowedInfo: "Information om tillåtna försök",
  maxAttemptsError: "Fel: Maximalt antal försök har överskridits",
  maximumAttemptsInfo: "Information om maximalt antal försök",
  limitedAttempts: "Begränsat antal försök",
  coolOffDescription: "Beskrivning av vänteperiod",
  noCoolOffPeriod: "Ingen vänteperiod",
  waitFor: "Vänta på",
  hours: "Timmar",
  days: "Dagar",
  whatLearnersWillSee: "Vad deltagarna kommer att se",
  unlimitedAttemptsInfo:
    "Du har ett obegränsat antal försök tillgängliga för denna bedömning.",
  waitBeforeNextAttemptPrefix: "Efter varje försök behöver du vänta",
  waitBeforeNextAttemptSuffix: "innan du kan starta ditt nästa försök.",
  waitBeforeNextAttempt:
    "Efter varje försök behöver du vänta {duration} innan du kan starta ditt nästa försök.",
  singleAttemptInfo: "Du har 1 försök tillgängligt för denna bedömning.",
  remainingAttemptsInfoPrefix: "Du har",
  remainingAttemptsInfoMiddle: "av",
  remainingAttemptsInfoSuffix: "försök tillgängliga för denna bedömning.",
  remainingAttemptsInfo:
    "Du har {remaining} av {total} försök tillgängliga för denna bedömning.",
  enableCertificate: "Aktivera certifikat",
  enableCertificateDescription:
    "Utfärda ett certifikat till kandidater som klarar bedömningen.",
  maxAllowed100: "Maximalt 100 tillåtet",
  scheduleAssessment: "Schemalägg bedömning",
  privateAssessmentLabel: "Privat bedömning",
  publicAssessmentLabel: "Offentlig bedömning",
  privateAssessmentDescription:
    "Den här bedömningen är endast inbjudningsbaserad och är tillgänglig strikt inom det definierade start- och sluttidsfönstret.",
  publicAssessmentDescription:
    "Den här bedömningen stöder både själv tilldelad och inbjudningsbaserad åtkomst, utan ett fast tidsfönster för åtkomst.",
  schedulePublicAssessment: "Schemalägg offentlig bedömning",
  successfullyPublishedAssessment: "Bedömningen har publicerats",
  publishWithoutProctoringPrompt: "Publicera utan övervakning (proctoring)?",
  publishAssessmentPrompt: "Publicera bedömning?",
  sectionScoreAnalysis: "Analys av avsnittsresultat",
  sectionScoreAnalysisOverview: "Översikt av analys för avsnittsresultat",
  section: "Avsnitt",
  noSectionDataAvailable: "Ingen avsnittsdata tillgänglig",
  difficultyLevelAnalysis: "Analys av svårighetsgrad",
  browserViolations: "Webbläsarinfrktioner",
  videoViolations: "Videoinfrktioner",
  times: "Gånger",
  statusMessageUnavailable: "Statusmeddelande ej tillgängligt",
  viewViolationEvidence: "Visa bevis på överträdelse",
  noBrowserViolationsDetected: "Inga webbläsarinfrktioner upptäcktes",
  noVideoViolationsDetected: "Inga videoinfrktioner upptäcktes",
  candidateNotAttemptedCodingMessage:
    "Meddelande: Kandidaten har inte försökt lösa programmeringsuppgiften",
  candidateCode: "Kandidatens kod",
  candidateScore: "Kandidatens poäng",
  compilationCount: "Antal kompileringar",
  submissionCount: "Antal inskickade bidrag",
  timeTaken: "Tid som krävts",
  testCaseReport: "Rapport över testfall",
  performanceAndCompilationMetrics: "Prestanda- och kompileringsmått",
  totalTestCases: "Totalt antal testfall",
  testCasesPassed: "Godkända testfall",
  testCaseDetails: "Information om testfall",
  searchQuestions: "Sök frågor",
  clearSearch: "Rensa sökning",
  question: "fråga",
  isSelected: "är markerad",
  areSelected: "är markerade",
  selected: "Markerad",
  questionsPerPage: "Frågor per sida:",
  publishQuestions: "Publicera frågor",
  send: "Skicka",
  move: "Flytta",
  publishQuestionsConfirmation:
    "Är du säker på att du vill publicera {{count}} {{label}}?",
  sendForReviewConfirmation:
    "Är du säker på att du vill skicka {{count}} {{label}} för granskning?",
  moveToDraftConfirmation:
    "Är du säker på att du vill flytta {{count}} {{label}} till utkast?",
  bulkPublishDisclaimer:
    "Kontrollera att alla valda frågor är fullständiga, korrekta och visas som avsett innan du publicerar.",
  bulkReviewDisclaimer:
    "Kontrollera att alla valda frågor är fullständiga, korrekta och visas som avsett innan du skickar för granskning.",
  bulkDraftDisclaimer:
    "Kontrollera att alla valda frågor är fullständiga, korrekta och visas som avsett innan du flyttar till utkast.",
  questionsUnderProcess:
    "Frågorna behandlas, vänligen klicka på 'visa information' för att kontrollera status.",
  mixedStatusesSelected: "Blandade statusar har valts",
  mixedStatusesWarning:
    "Se till du att alla valda frågor har samma status innan du fortsätter.",
  selectionLimitReached: "Urvalsgränsen har nåtts",
  selectionLimitWarning:
    "Du kan inte välja mer än {{count}} frågor för en massåtgärd. Avmarkera en fråga innan du väljer en annan.",
  knowMore: "Läs mer",
  guideLearnersRightDepth:
    "Vägled dina elever med frågor som matchar rätt djup.",
  bloomCreateDescription:
    "Utvärdera elevens förmåga att designa, arkitektera eller bygga nya system eller kodlösningar med hjälp av flera koncept.",
  bloomEvaluateDescription:
    "Kontrollera om eleven kritiskt kan bedöma kod, motivera val eller utvärdera olika lösningar.",
  bloomAnalyzeDescription:
    "Testa elevens förmåga att bryta ner kod, felsöka (debugga), spåra logik eller identifiera mönster i tekniska system.",
  bloomApplyDescription:
    "Utvärdera om eleven kan tillämpa koncept för att lösa praktiska kodningsproblem eller scenarier i den verkliga världen.",
  bloomUnderstandDescription:
    "Kontrollera om eleven kan förstå och förklara koncept med egna ord eller tolka beteenden.",
  bloomRememberDescription:
    "Utvärdera elevens förmåga att minnas grundläggande definitioner, syntax och faktainformation.",
  bloomVerbCreate: "Skapa",
  bloomVerbDesign: "Designa",
  bloomVerbConstruct: "Konstruera",
  bloomVerbDevelop: "Utveckla",
  bloomVerbEvaluate: "Utvärdera",
  bloomVerbJustify: "Motivera",
  bloomVerbDefend: "Försvara",
  bloomVerbAssess: "Bedöma",
  bloomVerbAnalyze: "Analysera",
  bloomVerbDifferentiate: "Diferensiera",
  bloomVerbOrganize: "Organisera",
  bloomVerbCompare: "Jämföra",
  bloomVerbApply: "Tillämpa",
  bloomVerbUse: "Använda",
  bloomVerbDemonstrate: "Demonstrera",
  bloomVerbSolve: "Lösa",
  bloomVerbExplain: "Förklara",
  bloomVerbDescribe: "Beskriva",
  bloomVerbSummarize: "Sammanfatta",
  bloomVerbInterpret: "Tolka",
  bloomVerbList: "Lista",
  bloomVerbDefine: "Definiera",
  bloomVerbName: "Namnge",
  bloomVerbRecall: "Minnas",
  bloomVerbRecognize: "Erkänna",
  bloomCreateExample1:
    "Skapa en enkelsidig applikation (SPA) med React och Redux.",
  bloomCreateExample2:
    "Designa ett schema för en databas till en samåkningsapp (ride-sharing).",
  bloomCreateExample3:
    "Utveckla en CI/CD-pipeline med hjälp av GitHub Actions.",
  bloomEvaluateExample1:
    "Utvärdera för- och nackdelar med att använda NoSQL istället för SQL i en mikrotjänstarkitektur.",
  bloomEvaluateExample2:
    "Rekommendera förbättringar för att optimera React-komponentens prestanda.",
  bloomAnalyzeExample1: "Jämför prestandan mellan merge sort och quicksort.",
  bloomAnalyzeExample2:
    "Analysera minnesanvändningen för denna rekursiva funktion.",
  bloomAnalyzeExample3: "Kategorisera felen i detta block av JavaScript-kod.",
  bloomApplyExample1:
    "Tillämpa den binära sökalgoritmen för att hitta ett element i en array.",
  bloomApplyExample2:
    "Använd en loop för att skriva ut Fibonacciserien i Python.",
  bloomApplyExample3: "Lös ett verkligt problem med hjälp av en hash-mapp.",
  bloomUnderstandExample1:
    "Förklara hur en stack fungerar med hjälp av LIFO-principen.",
  bloomUnderstandExample2:
    "Beskriv skillnaden mellan var, let och const i JavaScript.",
  bloomUnderstandExample3: "Tolka utdata från den givna SQL-frågan.",
  bloomRememberExample1:
    "Identifiera rätt HTML-tagg för att skapa en hyperlänk.",
  bloomRememberExample2:
    "Namnge de fyra pelarna inom objektorienterad programmering (OOP).",
  bloomRememberExample3: "Lista de primitiva datatyperna i Java.",
  commonVerbs: "Vanliga verb",
  exampleQuestions: "Exempelfrågor",
  noExamplesAvailable: "Inga exempel tillgängliga.",
  candidateResponse: "Kandidatens svar",
  correctQuestions: "Rätta frågor",
  totalQuestions: "Totalt antal frågor",
  correctQuestionPercentage: "Andel rätta frågor",
  performance: "Prestanda",
  level: "NIVÅ",
  noOfQuestions: "ANTAL FRÅGOR",
  correctAttempts: "KORREKTA FÖRSÖK",
  correctness: "KORREKTHET",
  partiallyCorrect: "DELVIS KORREKT",
  partiallyCorrectPercentage: "ANDEL DELVIS KORREKT",
  rescheduleAssessmentPrompt:
    "Vänligen bekräfta om du vill boka om bedömningen med titeln ”{{title}}”",
  assessmentAlreadyStarted: "Bedömningen har redan startat",
  readMore: "Läs mer",
  best: "Bästa",
  latest: "Senaste",
  allQuestions: "Alla frågor",
  myQuestions: "Mina frågor",
  publicQuestions: "Offentliga frågor",
  remarks: "Kommentarer",
  addRemarks: "Lägg till kommentarer",
  noGroupsAdded: "Inga grupper har lagts till ännu",
  addGroupInfo:
    "Börja med att skapa en grupp för att kunna lägga till frågor. Klicka på knappen ”Lägg till grupp i avsnitt” nedan för att komma igång.",
  exitPreview: "Avsluta förhandsgranskning",
  preview: "Förhandsgranskning",
  problemStatementNotAdded: "Problemformulering har inte lagts till",
  durationDayUnit: "dag",
  durationDaysUnit: "dagar",
  durationHourUnit: "tim",
  durationHoursUnit: "tim",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Anpassat fält {{fieldLabel}} tillagt för {{current}} av {{total}} språk",
  customFieldAddedForMultipleLanguages:
    "Anpassat fält {{fieldLabel}} tillagt för {{current}} av {{total}} språk",
  email: "E-post",
  tagInputHint: "Lägg till kommaseparerade värden",
  enterOptions: "Ange alternativ",
  groupNotFound: "Gruppen hittades inte",
  sheetNotFound: "Arket hittades inte",
  missingHeaders: "Obligatoriska rubriker saknas",
  assetNotFound: "Tillgången hittades inte",
  noValidDataFound: "Inga giltiga data hittades",
  notFoundPID: "Deltagaren hittades inte.",
  invalidParticipants: "Ogiltig deltagare.",
  alreadyAdded: "Deltagaren har redan lagts till.",
  duplicateData: "Duplicerade data hittades.",
  invalidData: "Ogiltiga data.",
  warnings: "Varningar",
  assignedToMyself: "Tilldelad till mig (Självstudie)",
  assignedByMe: "Tilldelad av mig (Mina Uppgifter)",
  urlCopiedToClipboard: "URL kopierad till urklipp!",
  failedToCopyUrl: "Det gick inte att kopiera URL.",
  content: "Innehåll",
  platformHelp: "Plattformshjälp",
  privacyPolicy: "Integritetspolicy",
  logout: "Logga ut",
  logoutConfirmTitle: "Är du säker på att du vill logga ut?",
  logoutConfirmDescription:
    "På väg ut? Du kan alltid komma tillbaka och fortsätta där du slutade.",
  stayEngaged: "Fortsätt vara aktiv"
} as const;
export default sv;
